import { render, staticRenderFns } from "./PlanMejoramientoI.vue?vue&type=template&id=1a435e8a&"
import script from "./PlanMejoramientoI.vue?vue&type=script&lang=js&"
export * from "./PlanMejoramientoI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports